import * as instrument from "../../../../assessments/instruments/sample/core-1-0-r1.js";
import type { Decorator } from "../../decorator.js";
import { formOrder } from "../../decorators/formOrder.js";
import { showWhen } from "../../decorators/showWhen.js";
import { defineRule } from "../../rules.js";
import type { SupportedVersions } from "../../supportedVersions.js";

const { groups, items } = instrument;

/** The order the instrument module lists, which a stored schema does not keep. */
export const order: Decorator = formOrder(instrument, {
  groups: [groups.life_functioning, groups.trauma],
  items: [
    items.school_attendance,
    items.school_behaviour,
    items.family_history,
    items.adjustment_to_trauma,
  ],
});

/** Family history is asked once school attendance needs action: rated 2 or more. */
export const familyHistoryWhenAttendanceConcerns: Decorator = showWhen(
  instrument,
  items.family_history,
  defineRule("attendanceIsAConcern", ({ answers }) => {
    const attendance = answers[items.school_attendance];

    return typeof attendance === "number" && attendance >= 2;
  }),
);

export const sampleCore_1_0: SupportedVersions = {
  versions: [["sample", "core", "1.0"]],
  decorators: [order, familyHistoryWhenAttendanceConcerns],
};
